import {Component, Input} from '@angular/core';
import {Address} from '../../../interface/address';

@Component({
  selector: 'app-table-address',
  templateUrl: './table-address.component.html',
  styleUrls: ['./table-address.component.scss']
})
export class TableAddressComponent {
  @Input() address: Address;
}
